import { render, staticRenderFns } from "./prodict.vue?vue&type=template&id=503f6012&scoped=true"
import script from "./prodict.vue?vue&type=script&lang=js"
export * from "./prodict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f6012",
  null
  
)

export default component.exports